import {
  Combobox,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
  ComboboxPopup,
} from "@/components/ui/combobox";

/** A free-text input with suggestions from values already stored on other
 * scripts. Anything typed is kept as-is — the suggestion list is a
 * shortcut, never a restriction. Value and input value are held in sync so
 * the combobox does not revert custom text to the last picked suggestion
 * when the popup closes. */
export function SuggestCombobox({
  value,
  onValueChange,
  suggestions,
  placeholder,
  ariaLabel,
}: {
  value: string;
  onValueChange: (value: string) => void;
  suggestions: string[];
  placeholder?: string;
  ariaLabel?: string;
}) {
  const query = value.trim().toLocaleLowerCase();
  const isCustom = query !== "" && !suggestions.some(s => s.trim().toLocaleLowerCase() === query);

  return (
    <Combobox<string>
      items={suggestions}
      value={value}
      onValueChange={next => onValueChange(next ?? "")}
      inputValue={value}
      onInputValueChange={next => onValueChange(next)}
    >
      <ComboboxInput aria-label={ariaLabel} placeholder={placeholder} showClear />
      <ComboboxPopup>
        <ComboboxEmpty>
          {isCustom ? `Keeping "${value.trim()}" as a new value.` : "No suggestions yet."}
        </ComboboxEmpty>
        <ComboboxList>
          {(item: string) => (
            <ComboboxItem key={item} value={item}>
              {item}
            </ComboboxItem>
          )}
        </ComboboxList>
      </ComboboxPopup>
    </Combobox>
  );
}
